import * as ActionTypes from '../action-types'

const drivers_DefaultState = {
    byID: {},
    pretripByID: {},
    schedulesByID: {},
    KPIDashboards: {
        driverLogsByCreatedAt: [],
        driverSumCurMonth: {},
        driverSumPrevMonth: {},
        topEvents: [],
    },
    allIDs: [],
    allDPIDs: [],
    selectedDRVID: '',
    startTime: 0,
    endTime: 0
}

export const drivers = (state = drivers_DefaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GET_DRIVERS: 
        case ActionTypes.CREATE_DRIVERS: {
            const drivers = action.drivers 

            drivers && drivers.length && drivers.map(driver => {

                const drvid = driver.drvid
                
                newState.byID[drvid] = driver

                if(!newState.allIDs.includes(drvid)) {
                    newState.allIDs.push(drvid)
                }
            })
            return newState
        }
        case ActionTypes.CREATE_DRIVER: 
        case ActionTypes.UPDATE_DRIVER: {
            const driver = action.driver

            newState.byID[driver.drvid] = driver

            return newState
        }
        case ActionTypes.CREATE_DRIVER_PRETRIP: 
        case ActionTypes.GET_DRIVER_PRETRIP_RECORDS_BY_DRVID: {
            const driverPretrips = action.driverPretrip
            const driverSchedules = action.driverSchedules

            const drvid = action.drvid
            const startTime = action.startTime
            const endTime = action.endTime

            newState.KPIDashboards = {}
            
            newState.startTime = startTime
            newState.endTime = endTime

            driverPretrips
            &&
            driverPretrips.length
            &&
            driverPretrips.map(pretrip => {
                const { dpid } = pretrip

                newState.pretripByID[dpid] = { ...pretrip, drvid }

                if(!newState.allDPIDs.includes(dpid)) {
                    newState.allDPIDs.push(dpid)
                }

                return -1;
            })

            driverSchedules
            &&
            driverSchedules.length
            &&
            driverSchedules.map(schedule => {
                const { date } = schedule

                newState.schedulesByID[date] = { ...schedule, drvid }

                // if(!newState.allDPIDs.includes(dpid)) {
                //     newState.allDPIDs.push(dpid)
                // }

                return -1;
            })

            return newState
        }
        case ActionTypes.GET_DRIVER_PERFORMANCE_DASHBOARD_DATA: {
            const driverScoreLog = action.driverScoreLog 
            const driverSummaryCurMonth = action.driverSummaryCurMonth 
            const driverSummaryPrevMonth = action.driverSummaryPrevMonth
            const topEvents = action.topEvents

            newState.byID = {}
            newState.pretripByID = {}
            newState.allIDs = []
            newState.allDPIDs = []
            newState.startTime = 0
            newState.endTime = 0

            newState.KPIDashboards.driverLogsByCreatedAt = driverScoreLog.sort((a, b) => a.createdAt - b.createdAt)
            newState.KPIDashboards.driverSumCurMonth = driverSummaryCurMonth
            newState.KPIDashboards.driverSumPrevMonth = driverSummaryPrevMonth
            newState.KPIDashboards.topEvents = topEvents

            return newState
        }
        case ActionTypes.SET_SCHEDULE_PRETRIP_SEARCH: {
            const drvid = action.drvid
            const startTime = action.startTime
            const endTime = action.endTime

            newState.selectedDRVID = drvid
            newState.startTime = startTime
            newState.endTime = endTime

            return newState
        }
        default:
            return newState
    }
}